import { Action } from '@ngrx/store';

import { ListItem } from '®shared/reading-list';

export enum ItemResolverStoreActionTypes {
  DRAFT_ITEM_REQUESTED = '[Item Resolver Store] Draft item requested',
  DRAFT_ITEM_LOADED = '[Item Resolver Store] Draft item loaded',
  DRAFT_ITEM_LOADING_FAILED = '[Item Resolver Store] Draft item loading failed',
  PUBLISHED_ITEM_REQUESTED = '[Item Resolver Store] Published item requested',
  PUBLISHED_ITEM_LOADED = '[Item Resolver Store] Published item loaded',
  PUBLISHED_ITEM_LOADING_FAILED = '[Item Resolver Store] Published item loading failed',
}

export interface ItemIdPayload {
  itemId: string;
}

export class DraftItemRequestedAction implements Action {
  readonly type = ItemResolverStoreActionTypes.DRAFT_ITEM_REQUESTED;

  constructor(public payload: ItemIdPayload) {}
}

export interface ItemLoadedPayload extends ItemIdPayload {
  item: ListItem;
}

export class DraftItemLoadedAction implements Action {
  readonly type = ItemResolverStoreActionTypes.DRAFT_ITEM_LOADED;

  constructor(public payload: ItemLoadedPayload) {}
}

export interface ItemLoadingFailedPayload extends ItemIdPayload {
  error: any;
}

export class DraftItemLoadingFailedAction implements Action {
  readonly type = ItemResolverStoreActionTypes.DRAFT_ITEM_LOADING_FAILED;

  constructor(public payload: ItemLoadingFailedPayload) {}
}

export class PublishedItemRequestedAction implements Action {
  readonly type = ItemResolverStoreActionTypes.PUBLISHED_ITEM_REQUESTED;

  constructor(public payload: ItemIdPayload) {}
}

export class PublishedItemLoadedAction implements Action {
  readonly type = ItemResolverStoreActionTypes.PUBLISHED_ITEM_LOADED;

  constructor(public payload: ItemLoadedPayload) {}
}

export class PublishedItemLoadingFailedAction implements Action {
  readonly type = ItemResolverStoreActionTypes.PUBLISHED_ITEM_LOADING_FAILED;

  constructor(public payload: ItemLoadingFailedPayload) {}
}

export type ItemResolverStoreActions =
  | DraftItemRequestedAction
  | DraftItemLoadedAction
  | DraftItemLoadingFailedAction
  | PublishedItemRequestedAction
  | PublishedItemLoadedAction
  | PublishedItemLoadingFailedAction;
